import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const getUserActivities = createAsyncThunk(
    'userActivities/getUserActivities',
    async ({pageSize, page, isMap, filters, lang}) => {
        const token = localStorage.getItem('ticino-wild-token');
        const url = `${process.env.REACT_APP_SERVER_BASE_URL}/activities/user-activities?lang=${lang}`;
        const headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        };
        const options = {
            method: 'POST',
            headers,
            body: JSON.stringify({
                pageSize,
                page,
                isMap: isMap || false,
                filters
            })
        }
        const response = await fetch(url, options);
        if (response.ok) {
            const result = await response.json();
            return result
        } else {
            const error = await response.json();
            throw error
        };
    }
)

const userActivitiesSlice = createSlice({
    name: 'userActivities',
    initialState: {
        isLoading: false,
        error: null,
        data: null,
        isNeedRefresh: false,
        activitiesAmount: null,
        pageSize: 12,
        page: 1,
        totalPages: null
    },
    reducers: {
        setIsNeedHomeRefresh: (state, action) => {
            state.isNeedRefresh = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getUserActivities.pending, (state) => {
                state.error = null;
                state.isLoading = true;
            })
            .addCase(getUserActivities.fulfilled, (state, action) => {
                state.data = action.payload.payload;
                state.activitiesAmount = action.payload.activitiesAmount;
                state.page = action.payload.page;
                state.totalPages = action.payload.totalPages;
                state.error = null;
                state.isLoading = false;
            })
            .addCase(getUserActivities.rejected, (state, action) => {
                if (action.error.message === "Nessuna attività trovata") state.data = []
                state.error = action.error;
                state.isLoading = false;
            })
    }
})

export const { setIsNeedHomeRefresh } = userActivitiesSlice.actions;
export default userActivitiesSlice.reducer;